var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var Share = function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 960 960", width: "1em", height: "1em" }, props),
    React.createElement("path", { d: "M800 640a159.82 159.82 0 0 0-125.85 61.3L314.53 521.49a160.09 160.09 0 0 0 0-83L674.15 258.7A159.82 159.82 0 0 0 800 320c88.22 0 160-71.78 160-160S888.22 0 800 0 640 71.78 640 160a159.54 159.54 0 0 0 5.47 41.49L285.85 381.3A159.82 159.82 0 0 0 160 320C71.78 320 0 391.78 0 480s71.78 160 160 160a159.82 159.82 0 0 0 125.85-61.3l359.62 179.81A159.54 159.54 0 0 0 640 800c0 88.22 71.78 160 160 160s160-71.78 160-160-71.78-160-160-160zm0-576a96 96 0 1 1-96 96 96.11 96.11 0 0 1 96-96zM160 576a96 96 0 1 1 96-96 96.11 96.11 0 0 1-96 96zm640 320a96 96 0 1 1 96-96 96.11 96.11 0 0 1-96 96z", fill: "currentColor", "data-name": "Layer 2" }))); };
export default Share;
//# sourceMappingURL=Share.js.map